<template>
    <span class="fts-32" :class="skinClass"  v-if="tomorrow">
        <template v-if="todayIsTransdate == 1">
            <template v-if="nowTimeSection == 0">
                <span>{{nowTime.months}}月</span><span>{{nowTime.days}}日</span><span class="text-data-desc">大盘涨跌竞猜中</span>
            </template>
            <template v-else-if="nowTimeSection == 1">
                <span>{{nowTime.months}}月</span><span>{{nowTime.days}}日</span><span class="text-data-desc">竞猜已结束</span>
                <div v-if="showNext">
               <span>{{baseConf.resultTime}}后可进行</span><span>{{tomorrow.months}}月</span><span>{{tomorrow.days}}日</span><span>的大盘</span>
                </div>
            </template>
            <template v-else-if="nowTimeSection == 2">
                <span>{{tomorrow.months}}月</span><span>{{tomorrow.days}}日</span><span class="text-data-desc">大盘涨跌竞猜中</span>
            </template>
        </template>
        <template v-else>
            <span>{{tomorrow.months}}月</span><span>{{tomorrow.days}}日</span><span class="text-data-desc">大盘涨跌竞猜中</span>
        </template>        
    </span>
</template>
<script>
    import {mapGetters,mapState} from 'vuex'
    export default {
        props : {
            skin:{
                type : Number,
                default : 0
            },
            showNext:{
                type : Boolean,
                default : false
            }
        },
        data() {
            return {
                
            }
        },
        computed: {
            ...mapGetters('home', ['nowTime', 'tomorrow', 'todayIsTransdate', 'nowTimeSection']),
            ...mapState('home', ['baseConf']),
            skinClass(){
                const {skin} = this
                if(skin){
                    return 'skin_' + skin
                }
                return ''
            }
        },
        methods: {
            
        },
    }
</script>